import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0052B4",
  d: "M23.894 10.436a11.95 11.95 0 0 0-3.411-6.92 11.95 11.95 0 0 0-6.92-3.412v10.331zM10.434.104a11.95 11.95 0 0 0-6.92 3.412 11.95 11.95 0 0 0-3.412 6.92h10.332zM.102 13.566a11.95 11.95 0 0 0 3.411 6.92 11.95 11.95 0 0 0 6.92 3.412V13.567zM13.563 23.898a11.95 11.95 0 0 0 6.92-3.412 11.95 11.95 0 0 0 3.411-6.92H13.563z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M16.097 7.615c0-.16.13-.29.29-.29h.62a1.78 1.78 0 0 0 1.776-1.777c0-.98-.797-1.777-1.777-1.777h-.588a1.23 1.23 0 0 0-.735-.233c-.593 0-1.074.385-1.074.86 0 .469.472.85 1.057.858v.003h1.34a.29.29 0 0 1 0 .579h-.62c-.98 0-1.777.797-1.777 1.777s.797 1.777 1.777 1.777h2.397V7.904h-2.397a.29.29 0 0 1-.289-.29M6.706 7.615c0-.16.13-.29.29-.29h.62c.98 0 1.777-.796 1.777-1.776a1.78 1.78 0 0 0-1.777-1.777h-.59a1.23 1.23 0 0 0-.733-.234c-.593 0-1.074.385-1.074.86 0 .47.471.85 1.057.858v.003h1.34a.29.29 0 0 1 0 .579h-.62c-.98 0-1.777.797-1.777 1.777s.797 1.777 1.777 1.777h2.397V7.904H6.996a.29.29 0 0 1-.29-.289M16.097 18.686c0-.16.13-.29.29-.29h.62c.98 0 1.776-.796 1.776-1.776a1.78 1.78 0 0 0-1.777-1.777h-.588a1.23 1.23 0 0 0-.735-.234c-.593 0-1.074.385-1.074.86 0 .47.472.85 1.057.858v.003h1.34a.29.29 0 0 1 0 .579h-.62c-.98 0-1.777.797-1.777 1.777s.797 1.777 1.777 1.777h2.397v-1.488h-2.397a.29.29 0 0 1-.289-.289M6.706 18.686c0-.16.13-.29.29-.29h.62c.98 0 1.777-.796 1.777-1.776s-.797-1.777-1.777-1.777h-.589a1.23 1.23 0 0 0-.734-.234c-.593 0-1.074.385-1.074.86 0 .47.471.85 1.057.858v.003h1.34a.29.29 0 0 1 0 .579h-.62c-.98 0-1.777.797-1.777 1.777s.797 1.777 1.777 1.777h2.397v-1.488H6.996a.29.29 0 0 1-.29-.289"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }